/**
 * Legendarios USA - Global Wishlist Manager
 * Gerenciador unificado de produtos favoritos com persistência via localStorage
 */
(function (window, document) {
  'use strict';

  var STORAGE_KEY = 'lgnd_wishlist_handles';

  var Wishlist = {
    /**
     * Retorna a lista de handles favoritados salvos no localStorage
     * @returns {string[]}
     */
    getWishlist: function () {
      try {
        var data = localStorage.getItem(STORAGE_KEY);
        if (!data) return [];
        var parsed = JSON.parse(data);
        return Array.isArray(parsed) ? parsed : [];
      } catch (err) {
        console.warn('[Wishlist] Erro ao carregar localStorage:', err);
        return [];
      }
    },

    /**
     * Salva a lista de handles no localStorage
     * @param {string[]} list
     */
    _saveWishlist: function (list) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (err) {
        console.warn('[Wishlist] Erro ao salvar localStorage:', err);
      }
    },

    /**
     * Verifica se um produto está nos favoritos
     * @param {string} handle
     * @returns {boolean}
     */
    isFavorited: function (handle) {
      if (!handle) return false;
      var list = this.getWishlist();
      return list.indexOf(String(handle).trim()) !== -1;
    },

    /**
     * Adiciona um produto aos favoritos
     * @param {string} handle
     * @returns {boolean}
     */
    add: function (handle) {
      if (!handle) return false;
      var cleanHandle = String(handle).trim();
      var list = this.getWishlist();
      if (list.indexOf(cleanHandle) === -1) {
        list.push(cleanHandle);
        this._saveWishlist(list);
        this._broadcast(cleanHandle, true);
        return true;
      }
      return false;
    },

    /**
     * Remove um produto dos favoritos
     * @param {string} handle
     * @returns {boolean}
     */
    remove: function (handle) {
      if (!handle) return false;
      var cleanHandle = String(handle).trim();
      var list = this.getWishlist();
      var idx = list.indexOf(cleanHandle);
      if (idx !== -1) {
        list.splice(idx, 1);
        this._saveWishlist(list);
        this._broadcast(cleanHandle, false);
        return true;
      }
      return false;
    },

    /**
     * Alterna o estado de favorito de um produto
     * @param {string} handle
     * @returns {boolean} Novo estado (true = favoritado, false = removido)
     */
    toggle: function (handle) {
      if (!handle) return false;
      var cleanHandle = String(handle).trim();
      if (this.isFavorited(cleanHandle)) {
        this.remove(cleanHandle);
        return false;
      } else {
        this.add(cleanHandle);
        return true;
      }
    },

    /**
     * Dispara evento global e sincroniza a interface
     * @param {string} handle
     * @param {boolean} isFav
     */
    _broadcast: function (handle, isFav) {
      this.syncUI();

      try {
        var event = new CustomEvent('wishlist:updated', {
          detail: { handle: handle, isFavorited: isFav, list: this.getWishlist() }
        });
        window.dispatchEvent(event);
      } catch (e) {}
    },

    /**
     * Sincroniza todos os botões de favoritos presentes na tela
     * @param {HTMLElement} [container=document]
     */
    syncUI: function (container) {
      var root = container || document;
      var list = this.getWishlist();

      var buttons = root.querySelectorAll(
        '[data-wishlist-btn], .showcase-wishlist-btn, .lgnd-wishlist-toggle, .wishlist--btn'
      );

      buttons.forEach(function (btn) {
        var handle = btn.getAttribute('data-product-handle');
        if (!handle) {
          var card = btn.closest('.showcase-card, .legendarios-product-page, .lgnd-recom-card');
          if (card) {
            var link = card.querySelector('a[href*="/products/"]');
            if (link) {
              var match = link.getAttribute('href').match(/\/products\/([a-zA-Z0-9\-_]+)/);
              if (match && match[1]) {
                handle = match[1].split('?')[0];
                btn.setAttribute('data-product-handle', handle);
              }
            }
          }
        }

        if (!handle) return;

        var isFav = list.indexOf(handle) !== -1;

        var docLang = (document.documentElement.lang || (document.querySelector('html') && document.querySelector('html').getAttribute('lang')) || navigator.language || 'en').toLowerCase();

        var textAdd = btn.getAttribute('data-title-add') || window.wishlist_words_add;
        var textRemove = btn.getAttribute('data-title-remove') || window.wishlist_words_remove;

        // Se o documento estiver em outro idioma mas o texto for o fallback inglês ou estiver vazio
        var isEnDoc = docLang.indexOf('en') === 0;
        var needsLangOverride = !textAdd || !textRemove || (!isEnDoc && textAdd === 'Add to wishlist');

        if (needsLangOverride) {
          if (docLang.indexOf('pt') === 0) {
            textAdd = 'Adicionar aos favoritos';
            textRemove = 'Remover dos favoritos';
          } else if (docLang.indexOf('es') === 0) {
            textAdd = 'Agregar a favoritos';
            textRemove = 'Eliminar de favoritos';
          } else if (docLang.indexOf('de') === 0) {
            textAdd = 'Zur Wunschliste hinzufügen';
            textRemove = 'Von der Wunschliste entfernen';
          } else if (docLang.indexOf('fr') === 0) {
            textAdd = 'Ajouter aux favoris';
            textRemove = 'Supprimer des favoris';
          } else {
            textAdd = textAdd || 'Add to wishlist';
            textRemove = textRemove || 'Remove from wishlist';
          }
        }

        if (isFav) {
          btn.classList.add('active', 'is-active', 'favorite');
          btn.classList.remove('unfavorite');
          btn.setAttribute('aria-pressed', 'true');
          btn.setAttribute('title', textRemove);
          btn.setAttribute('aria-label', textRemove);
        } else {
          btn.classList.remove('active', 'is-active', 'favorite');
          btn.classList.add('unfavorite');
          btn.setAttribute('aria-pressed', 'false');
          btn.setAttribute('title', textAdd);
          btn.setAttribute('aria-label', textAdd);
        }
      });
    },

    /**
     * Inicializa os ouvintes de eventos e o estado inicial
     */
    init: function () {
      var self = this;

      // Sincronização inicial da interface
      self.syncUI();

      // Delegação de cliques global para qualquer botão de wishlist
      document.addEventListener('click', function (e) {
        var btn = e.target.closest(
          '[data-wishlist-btn], .showcase-wishlist-btn, .lgnd-wishlist-toggle, .wishlist--btn'
        );

        if (!btn) return;

        // Impede que o clique no botão submeta formulário ou navegue para o produto
        e.preventDefault();
        e.stopPropagation();

        var handle = btn.getAttribute('data-product-handle');
        if (!handle) {
          var card = btn.closest('.showcase-card, .legendarios-product-page, .lgnd-recom-card');
          if (card) {
            var link = card.querySelector('a[href*="/products/"]');
            if (link) {
              var match = link.getAttribute('href').match(/\/products\/([a-zA-Z0-9\-_]+)/);
              if (match && match[1]) {
                handle = match[1].split('?')[0];
                btn.setAttribute('data-product-handle', handle);
              }
            }
          }
        }

        if (!handle) {
          console.warn('[Wishlist] Produto sem handle identificado no elemento:', btn);
          return;
        }

        // Alterna o status
        self.toggle(handle);

        // Adiciona micro-animação de pulso
        btn.classList.add('lgnd-heart-pulse');
        setTimeout(function () {
          btn.classList.remove('lgnd-heart-pulse');
        }, 450);
      });

      // Sincronização entre abas do navegador
      window.addEventListener('storage', function (e) {
        if (e.key === STORAGE_KEY) {
          self.syncUI();
        }
      });
    }
  };

  // Expõe no objeto global
  window.LegendariosWishlist = Wishlist;

  // Auto inicialização quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      Wishlist.init();
    });
  } else {
    Wishlist.init();
  }
})(window, document);
